export interface CoinbaseHolding {
  id: number;
  user_id: number;
  token_symbol: string;
  amount: number;
  created_at: string;
  updated_at: string;
}

export interface UpdateCoinbaseHoldingsRequest {
  holdings: {
    token_symbol: string;
    amount: number;
  }[];
}

export async function fetchCoinbaseHoldings(userId: number, token: string): Promise<CoinbaseHolding[]> {
  const response = await fetch(`/api/users/${userId}/coinbase-holdings`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || `Failed to fetch coinbase holdings: ${response.statusText}`);
  }
  
  const data = await response.json();
  return data.holdings;
}

export async function fetchUserCoinbaseHoldings(userId: number, token: string): Promise<CoinbaseHolding[]> {
  const response = await fetch(`/api/users/${userId}/coinbase-holdings/own`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || `Failed to fetch user coinbase holdings: ${response.statusText}`);
  }
  
  const data = await response.json();
  return data.holdings;
}

export async function updateCoinbaseHoldings(userId: number, holdings: UpdateCoinbaseHoldingsRequest, token: string): Promise<CoinbaseHolding[]> {
  const response = await fetch(`/api/users/${userId}/coinbase-holdings`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(holdings),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || `Failed to update coinbase holdings: ${response.statusText}`);
  }
  
  const data = await response.json();
  return data.holdings;
}

export async function deleteCoinbaseHolding(userId: number, tokenSymbol: string, token: string): Promise<void> {
  const response = await fetch(`/api/users/${userId}/coinbase-holdings/${tokenSymbol}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || `Failed to delete coinbase holding: ${response.statusText}`);
  }
}
